import { WLIDS } from 'Constants';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { NewModal } from 'Views/Components/Modal/NewModal';

interface ErrorModalProps {
	onClose: () => void;
	children?: ReactNode;
}

export default function ErrorModal({ onClose, children }: ErrorModalProps) {
	return (
		<>
			<NewModal.Header>
				<NewModal.Title>
					<FormattedMessage id={WLIDS.standby.modalTitle} defaultMessage="Join standby" />
				</NewModal.Title>
			</NewModal.Header>
			<NewModal.Body>{children}</NewModal.Body>
			<NewModal.Footer>
				<NewModal.ConfirmButton onClick={onClose}>Close</NewModal.ConfirmButton>
			</NewModal.Footer>
		</>
	);
}
